enum AccountAnalyticsToolName {
  AccountAvailableMetrics = 'account-available-metrics',
  AccountAvailableDimensions = 'account-available-dimensions',
  CreateAccountDashboard = 'create-account-dashboard',
  RenameAccountDashboard = 'rename-account-dashboard',
  DeleteAccountDashboard = 'delete-account-dashboard',
  AccountTopPerforming = 'account-top-performing',
  AccountAnalyticsData = 'account-analytics-data',
  HighlightAccountWidget = 'highlight-account-widget',
  CheckAccountWidgetExists = 'check-account-widget-exists',
  DeleteAccountWidget = 'delete-account-widget',
  UpdateAccountWidget = 'update-account-widget',
  CreateAccountWidget = 'create-account-widget',
  GetAccountFilterValues = 'get-account-filter-values',
  AccountAnalyticsTableData = 'account-analytics-table-data',
  AccountWorstPerforming = 'account-worst-performing',

  NavigateToAccountDashboard = 'navigate-to-account-dashboard',
}

export {AccountAnalyticsToolName};
